import React from 'react';
import styled from 'styled-components';

export default function Button({ Icon, text, width, height, padding, gap, backgroundColor, border, borderRadius, fontSize, fontWeight, textColor, disabled = false, onClick, ...props }) {
  return (
    <StyledButton 
        $width={width}
        $height={height}
        $padding={padding}
        $backgroundColor={backgroundColor}
        $border={border}
        $borderRadius={borderRadius}
        $fontSize={fontSize}
        $fontWeight={fontWeight}
        $textColor={textColor}
        disabled={disabled}
        onClick={onClick}
        {...props}
    >
        {Icon && <Icon />}
        {text}
    </StyledButton>
  );
}

const StyledButton = styled.button`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  
    width: ${props => props.$width};
    height: ${props => props.$height};
    margin: ${props => props.$margin || '0'};
    padding: ${props => props.$padding || '0'};
    gap: ${props => props.$gap || '5px'};

    background-color: ${props => props.$backgroundColor || 'transparent'};
    border:  ${props => props.$border || 'none'};
    border-radius: ${props => props.$borderRadius};

    font-size: ${props => props.$fontSize};
    font-weight: ${props => props.$fontWeight};
    color: ${props => props.$textColor};

    cursor: ${props => props.disabled ? 'default' : 'pointer'};
`;
